export const initialState = {
  project: {},
};
